import { endpoint } from "../../utils/constants";

const crewLogin = `${endpoint}/auth/equipe-sesi/login`;
const contractInfo = `${endpoint}/contracts/`;
const contractAssociatedInfo = `${endpoint}/contracts/associated/`;
const formContract = `${endpoint}/contracts/pre-contract`;
const privateFormContrat = `${endpoint}/contracts/pre-contract/private`;
const cities = `${endpoint}/contracts/cities/all`;
const clubs = `${endpoint}/contracts/club/all`;
const clubContract = `${endpoint}/contracts/club/`;
const clubContractByDate = `${endpoint}/contracts/club/filters/date?`;
const attInfoPerson = `${endpoint}/contracts/person/update`;
const showContractDetails = `${endpoint}/contracts/details/`;
const listPlansByClub = `${endpoint}/contracts/club/`;
const planModification = `${endpoint}/contracts/change/plan`;
const clubsUser = `${endpoint}/upload/clubs`;

export const crewLoginRequest = async (
  user: String,
  pswd: String
): Promise<any> => {
  try {
    const response = await fetch(crewLogin, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
      },
      body: JSON.stringify({
        user_login: user,
        password: pswd,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();

    console.log(responseData, "Retorno API crewLoginRequest");

    return responseData;
  } catch (error) {
    console.error("Erro na requisição de login:", error);
    throw error;
  }
};

export const findContract = async (contractId: String) => {
  const response = await fetch(`${contractInfo}${contractId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API Contracts");

  return responseData;
};

export const findContractAssociated = async (cpfcnpj: String) => {
  const response = await fetch(`${contractAssociatedInfo}${cpfcnpj}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API Contracts Associated");

  return responseData;
};

export const sendForm = async (
  cpf: string,
  name: string,
  phone: string,
  cep: string,
  street: string,
  email: string,
  neighborhood: string,
  number: string,
  compliment: string,
  city: number,
  state: number,
  id_clube: number,
  requestDate: string,
  companyId: number,
  categoryId: number,
  groupId: number,
  numContrato: number,
  id_contrato: number,
  dependents: {
    Nome_dependente: string;
    Grau_parentesco: number;
    Telefone_dependente: string;
    CPF_dependente: string;
    Email_dependente: string;
  }[]
): Promise<any> => {
  const payload = {
    CPF: cpf,
    Nome: name,
    Telefone: phone,
    CEP: cep,
    Email: email,
    Bairro: neighborhood,
    logradouro: street,
    Numero: number,
    Complemento: compliment,
    id_cidade: city,
    id_uf: state,
    id_clube: id_clube,
    Data_solicitacao: requestDate,
    Id_Empresa: companyId,
    Id_categoria: categoryId,
    Id_grupo: groupId,
    num_contrato: numContrato,
    id_contrato: id_contrato,
    Dependentes: dependents,
  };

  console.log("Envio", JSON.stringify(payload));

  const response = await fetch(formContract, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(
      `HTTP error! Status: ${response.status} - ${await response.text()}`
    );
  }

  const responseData = await response.json();

  console.log(responseData, "Retorno API sendForm");

  return responseData;
};

export const privateSendForm = async (
  cnpj: string,
  dataInclusao: Date,
  dataFinalizacao: string | null,
  nome: string,
  cpf: string,
  dataNasc: Date,
  idSexo: number | null,
  email: string,
  cep: string,
  logradouro: string,
  numero: string,
  complemento: string,
  idCidade: number,
  idUf: number,
  telefone: string,
  celular: string,
  idUsuarioProc: number,
  dataProc: string | null,
  selecionar: any, // ajustar tipo conforme necessário
  bairro: string | null,
  idAssociado: number,
  dependents: {
    Nome_dependente: string;
    Grau_parentesco: number;
    Telefone_dependente: string;
    CPF_dependente: string;
    Email_dependente: string;
  }[]
): Promise<any> => {
  const payload = {
    CNPJ: cnpj,
    DATA_INCLUSAO: dataInclusao,
    DATA_FINALIZACAO: dataFinalizacao,
    NOME: nome,
    CPF: cpf,
    DATA_NASC: dataNasc,
    ID_SEXO: idSexo,
    EMAIL: email,
    CEP: cep,
    LOGRADOURO: logradouro,
    NUMERO: numero,
    COMPLEMENTO: complemento,
    ID_CIDADE: idCidade,
    ID_UF: idUf,
    TELEFONE: telefone,
    CELULAR: celular,
    ID_USUARIO_PROC: idUsuarioProc,
    DATA_PROC: dataProc,
    SELECIONAR: selecionar,
    BAIRRO: bairro,
    ID_ASSOCIADO: idAssociado,
    DEPENDENTES: dependents,
  };

  console.log("Envio", JSON.stringify(payload));

  const response = await fetch(privateFormContrat, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(
      `HTTP error! Status: ${response.status} - ${await response.text()}`
    );
  }

  const responseData = await response.json();

  console.log(responseData, "Retorno API sendForm");

  return responseData;
};

export const fetchCities = async () => {
  const response = await fetch(`${cities}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API getCities");

  return responseData;
};

export const fetchClubs = async () => {
  const response = await fetch(`${clubs}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API fetchClubs");

  return responseData;
};

export const fetchContractsByClubId = async (clubId: string) => {
  const response = await fetch(`${clubContract}${clubId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API fetchContractsByClubId");

  return responseData;
};

export const fetchContractsByDate = async (
  contractId: string,
  startDate: string,
  endDate: string
) => {
  const url = `${clubContractByDate}id=${contractId}&start_date=${startDate}&end_date=${endDate}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API fetchContractsByDate");

  return responseData;
};

export const attInfo = async (
  id: String,
  cep: String,
  logradouro: string,
  numero: string,
  complemento: string,
  bairro: string,
  id_cidade: number,
  uf: number,
  email: string,
  celular: string
): Promise<any> => {
  try {
    const response = await fetch(attInfoPerson, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
      },
      body: JSON.stringify({
        id_associado: id,
        cep: cep,
        logradouro: logradouro,
        numero: numero,
        complemento: complemento,
        bairro: bairro,
        id_cidade: id_cidade,
        uf: uf,
        EMAIL_COB: email,
        CELULAR_COB: celular,
        EMAIL_PORTAL: email,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();

    console.log(responseData, "Retorno API attInfo");

    return responseData;
  } catch (error) {
    console.error("Erro na requisição attInfo:", error);
    throw error;
  }
};

export const fetchContractDetails = async (contractId: string) => {
  const response = await fetch(`${showContractDetails}${contractId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API fetchContractDetails");

  return responseData;
};

export const fetchPlansByClub = async (clubId: String) => {
  console.log(`${listPlansByClub}${clubId}/plans`, "Mandando")
  const response = await fetch(`${listPlansByClub}${clubId}/plans`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  const responseData = await response.json();

  console.log(responseData, "Retorno API Contracts Associated");

  return responseData;
};

interface Dependent {
  nome: string;
  cpf: string;
  telefone: string;
  email: string;
  id_contrato: number;
  grau_parentesco: number;
}

export const sendPlanModification = async (
  contract_id: number,
  categoryId?: number,
  agreementId?: number,
  dependents?: Dependent[]
) => {
  try {
    console.log(
      JSON.stringify({
        id_contrato: contract_id,
        id_categoria: categoryId,
        id_convenio: agreementId,
        dependentes: dependents || [],
      }),
      "Enviando modificação"
    )
    const response = await fetch(planModification, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
      },
      body: JSON.stringify({
        id_contrato: contract_id,
        id_categoria: categoryId,
        id_convenio: agreementId,
        dependentes: dependents || [],
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();

    console.log(responseData, "Retorno API sendPlanModification");

    return responseData;
  } catch (error) {
    console.error("Erro na requisição de sendPlanModification", error);
    throw error;
  }
};

export const fetchRelationships = async () => {
  const url = `${endpoint}/contracts/all/relationships`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const responseData = await response.json();

  console.log(responseData, "Retorno API fetchRelationships");

  return responseData;
};

export const fetchLimitedRelationships = async (categoryId: string) => {
  const url = `${endpoint}/contracts/relatives/limit?id_categoria=${categoryId}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const responseData = await response.json();

  console.log(responseData, "Retorno API fetchRelationships");

  return responseData;
};

export const fetchUnidades = async () => {
  const url = `${endpoint}/contracts/club/all/eclube`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const responseData = await response.json();
  console.log(responseData, "Retorno API fetchUnidades");

  return responseData;
};

export const fetchDocuments = async (prefix: string) => {
  const url = `${endpoint}/upload/documents?prefix=${prefix}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const responseData = await response.json();

  return responseData;
};

export const fetchClubsByUser = async () => {
  const response = await fetch(clubsUser, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")!}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const responseData = await response.json();

  return responseData;
};
